import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const HIDDEN_RELOAD_THRESHOLD_MS = 15 * 60 * 1000;
const HIDDEN_AT_KEY = "pageHiddenAt";

const PUBLIC_PATHS = ["/", "/pass"];

const isPublicPath = (path: string) =>
    PUBLIC_PATHS.some((p) => path === p || path.startsWith(`${p}/`));

const PageLifecycleHandler: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                try {
                    sessionStorage.setItem(HIDDEN_AT_KEY, Date.now().toString());
                } catch {
                }
                return;
            }

            if (document.visibilityState !== "visible") return;

            let hiddenAt = 0;
            try {
                hiddenAt = parseInt(sessionStorage.getItem(HIDDEN_AT_KEY) || "0", 10);
            } catch {
                hiddenAt = 0;
            }

            try {
                sessionStorage.removeItem(HIDDEN_AT_KEY);
            } catch {
            }

            if (!hiddenAt) return;

            const hiddenFor = Date.now() - hiddenAt;

            if (
                hiddenFor > HIDDEN_RELOAD_THRESHOLD_MS &&
                !isPublicPath(window.location.pathname)
            ) {
                window.location.reload();
            }
        };

        const handlePageShow = (event: PageTransitionEvent) => {
            if (event.persisted && !isPublicPath(window.location.pathname)) {
                window.location.reload();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("pageshow", handlePageShow);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("pageshow", handlePageShow);
        };
    }, [location.pathname]);

    return null;
};

export default PageLifecycleHandler;
